<template>
  <i class="placeholder" />
</template>

<script setup lang="ts">
import useEazyChat from '~/composables/useEazyChat';
const { initialize } = useEazyChat();

onNuxtReady(() => {
  const events = ["mousedown", "mousemove", "keydown", "touchstart", "scroll"]; const init = () => { initialize({}, "chat-button"); events.forEach((event) => { window.removeEventListener(event, init); }); }; events.forEach((event) => { window.addEventListener(event, init, { once: true, passive: true }); });
});
</script>

<style lang="postcss">
.chat-button {
  right: var(--unit-8) !important;

  @media (--md-viewport) {
    bottom: var(--unit-2) !important;
  }
}
</style>

<style lang="postcss" scoped>
.placeholder {
  display: none;
  visibility: hidden;
  pointer-events: none;
}
</style>
